import { render, staticRenderFns } from "./ReviewCardHeader.vue?vue&type=template&id=980325d8&scoped=true&"
import script from "./ReviewCardHeader.vue?vue&type=script&lang=js&"
export * from "./ReviewCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCardHeader.vue?vue&type=style&index=0&id=980325d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980325d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRating } from 'vuetify/lib/components/VRating';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VImg,VRating,VTooltip})
